var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15075_12995)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15075_12995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.09808e-05H27.4286V27.4286H0V2.09808e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15075_12995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.803589 4.82141V0.803554H4.82145",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2858 0.803554H23.3036V4.82141",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82145 23.3036H0.803589V19.2857",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21423 10.4464H8.03566",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0893 10.4464H13.6608V4.01784H20.0893V10.4464Z",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4464 20.0894H4.01782V13.6608H10.4464V20.0894Z",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15075_12995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.09808e-05H27.4286V27.4286H0V2.09808e-05Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15075_12995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3392 15.3214H20.9464",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1249 13.7143H13.7142V17.7322",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7321 16.9286H19.3392",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5178 16.9286H16.125",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 18.5356H17.7321",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1428 17.7321V20.9464",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 15.3214H17.7321",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7321 13.7142H20.9463",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42859 16.875H8.03573",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0714 7.23218H17.6786",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64282 5.625H11.25",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42854 4.01791H4.01782V8.03577",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03564 7.23218H9.64279",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82141 7.23218H6.42855",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42859 8.83923H8.03573",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4464 8.03571V11.25",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42859 5.625H8.03573",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03564 4.01782H11.2499",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_15075_12995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 0,
    width: 28,
    height: 28
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.09808e-05H-3.42857V27.4286H24V2.09808e-05Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_15075_12995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1786 23.3036H23.1964V19.2857",
    stroke: "#333333",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15075_12995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.bfb31f5bd4481aa49da04d9fc6f0ec80.svg";
export { ForwardRef as ReactComponent };